"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJCreditsScene = void 0;
const CGJGeneralMenuScene_1 = require("./CGJGeneralMenuScene");
const KHMenuSpec_1 = require("./KH/Menu/KHMenuSpec");
class CGJCreditsScene extends CGJGeneralMenuScene_1.CGJGeneralMenuScene {
    constructor() {
        super("CGJCreditsScene", false);
    }
    onCreate() {
        return new KHMenuSpec_1.KHMenuSpec("", [
            this.addText(.5, .1, "Game By", .1),
            this.addLink(.5, .2, "Kevin Hutchins", "https://khutchins.itch.io/", .15),
            this.addText(.5, .4, "Assets Used", .1),
            this.addLink(.5, .5, "Character Sprites by Lanea Zimmerman", "https://opengameart.org/content/tiny-16-basic", .08),
            this.addLink(.5, .6, "Apple Sprite by Master484", "https://opengameart.org/content/good-fruits-m484-games", .08),
            this.addLink(.5, .7, "Grass Tiles by George Bailey", "https://opengameart.org/content/16x16-game-assets", .08),
            this.addLink(.5, .8, "Music by Joth", "https://opengameart.org/users/joth", .08),
        ], this.addConditionalBackOption());
    }
}
exports.CGJCreditsScene = CGJCreditsScene;
